module.exports = __webpack_public_path__ + "img/mit_liebe_verpackt.c1b0f31.svg";